/* eslint-disable react/prop-types */
import React from 'react';
import image from './City.jpeg';
import { connectStateResults } from 'react-instantsearch-dom';

const NoResults = ({ searchResults }) => {
  if (!searchResults || searchResults.nbHits > 0) {
    return null;
  }


  return (
    <div className="./hits-empty-state">
       <img src={image} alt="DNA" />
	   <br /><br /><br /><br /><br /><br /><br /><br /><br />
	   <br /><br /><br /><br /><br /><br /><br /><br /><br />
	   <br /><br /><br /><br /><br /><br /><br /><br /><br />
	   <br /><br /><br /><br />
    </div>
  );
};

export default connectStateResults(NoResults);
